import { DrawerServiceKey, type DrawerService } from '@/plugins/drawerService';
import { inject } from 'vue';

export function useDrawer(): DrawerService {
    const service = inject(DrawerServiceKey);
    if (!service) throw new Error('useDrawer() requires DrawerServicePlugin to be installed');
    return service;
}
